export const en = {
    appTitle: "Sport Empire",
    sidebar: {
        home: "Home",
        teams: "Teams",
        tournaments: "Tournaments",
        tournamentCategories: "Tournament Categories",
        players: "Players",
        matches: "Matches",
        "match-participants": "Match Participants",
        "match-events": "Match Events",
        files: "Files",
        news: "News",
        statistics: "Statistics",
        permissions: "Permissions",
        achievements: "Achievements",
        regions: "Regions",
        categories: "Categories",
        sportTypes: "Sport Types",
        playgrounds: "Playgrounds",
        countries: "Countries",
        cities: "Cities",
        users: "Users",
        sportClubs: "Sport Clubs",
        favorites: "Favorites",
        leagueAdmins: "League Admins",
        myLeague: "My League",
        createLeague: "Create Top League",
        createDivision: "Create Lower League",
        createLeagueTeam: "Create Team",
        createLeaguePlayer: "Create Player"
    },
    navigation: {
        dashboard: "Dashboard",
        tournamentCategories: "Tournament Categories"
    },
    nav: {
        dashboard: "Dashboard"
    },
    news: {
        title: "News",
        subtitle: "Manage news articles and announcements",
        createNews: "Create News",
        editNews: "Edit News",
        noNews: "No news found",
        createFirst: "Create your first news article",
        newsTitle: "Title",
        newsContent: "Content",
        newsExcerpt: "Excerpt",
        newsSlug: "Slug",
        newsTags: "Tags",
        newsCategory: "Category",
        newsAuthor: "Author",
        newsImage: "Featured Image",
        newsStatus: "Status",
        newsPublishDate: "Publish Date",
        newsViews: "Views",
        newsShares: "Shares",
        newsComments: "Comments",
        newsLikes: "Likes",
        searchPlaceholder: "Search news...",
        filterByStatus: "Filter by status",
        filterByCategory: "Filter by category",
        filterByAuthor: "Filter by author",
        filterByTags: "Filter by tags",
        allStatuses: "All Statuses",
        allCategories: "All Categories",
        allAuthors: "All Authors",
        clearFilters: "Clear Filters",
        showFilters: "Show Filters",
        hideFilters: "Hide Filters",
        publishNews: "Publish",
        archiveNews: "Archive",
        deleteNews: "Delete",
        duplicateNews: "Duplicate",
        previewNews: "Preview",
        saveNews: "Save",
        saveDraft: "Save as Draft",
        publishNow: "Publish Now",
        schedulePublish: "Schedule Publish",
        cancelEdit: "Cancel",
        statistics: "Statistics",
        overview: "Overview",
        totalNews: "Total News",
        publishedNews: "Published",
        draftNews: "Drafts",
        archivedNews: "Archived",
        recentNews: "Recent News",
        popularNews: "Popular News",
        totalViews: "Total Views",
        totalShares: "Total Shares",
        totalComments: "Total Comments",
        totalLikes: "Total Likes",
        addTag: "Add Tag",
        removeTag: "Remove Tag",
        enterTag: "Enter tag name",
        slugUnavailable: "This slug is already taken",
        slugAvailable: "This slug is available",
        checkingSlug: "Checking slug availability...",
        generateSlug: "Generate from title",
        required: "This field is required",
        titleRequired: "Title is required",
        contentRequired: "Content is required",
        excerptRequired: "Excerpt is required",
        slugRequired: "Slug is required",
        categoryRequired: "Category is required",
        status: {
            draft: "Draft",
            published: "Published",
            archived: "Archived",
            scheduled: "Scheduled"
        },
        actions: {
            create: "Create News",
            edit: "Edit",
            delete: "Delete",
            publish: "Publish",
            archive: "Archive",
            duplicate: "Duplicate",
            preview: "Preview",
            save: "Save",
            cancel: "Cancel"
        },
        confirmDelete: "Are you sure you want to delete this news article?",
        confirmArchive: "Are you sure you want to archive this news article?",
        confirmPublish: "Are you sure you want to publish this news article?",
        newsCreated: "News article created successfully",
        newsUpdated: "News article updated successfully",
        newsDeleted: "News article deleted successfully",
        newsPublished: "News article published successfully",
        newsArchived: "News article archived successfully",
        errorCreating: "Error creating news article",
        errorUpdating: "Error updating news article",
        errorDeleting: "Error deleting news article",
        errorPublishing: "Error publishing news article",
        errorArchiving: "Error archiving news article",
        errorLoading: "Error loading news articles",
        loadingNews: "Loading news...",
        savingNews: "Saving news...",
        publishingNews: "Publishing news...",
        archivingNews: "Archiving news...",
        deletingNews: "Deleting news...",
        loadMore: "Load More",
        noMoreNews: "No more news to load",
        sortBy: "Sort by",
        sortByTitle: "Title",
        sortByDate: "Date",
        sortByViews: "Views",
        sortByStatus: "Status",
        sortAscending: "Ascending",
        sortDescending: "Descending",
        itemsPerPage: "Items per page",
        showing: "Showing",
        of: "of",
        results: "results",
        page: "Page",
        nextPage: "Next",
        prevPage: "Previous",
        firstPage: "First",
        lastPage: "Last",
        featured: "Featured",
        breaking: "Breaking News",
        metaTitle: "Meta Title",
        metaDescription: "Meta Description"
    },
    auth: {
        loginTitle: "Log In",
        loginSubtitle: "Enter your credentials to access your account",
        registerTitle: "Create Account",
        registerSubtitle: "Enter your details to register",
        phone: "Phone Number",
        password: "Password",
        firstname: "First Name",
        lastname: "Last Name",
        forgotPassword: "Forgot password?",
        loginButton: "Log In",
        registerButton: "Register",
        loggingIn: "Logging in...",
        creatingAccount: "Creating account...",
        noAccount: "Don't have an account?",
        haveAccount: "Already have an account?",
        register: "Register",
        login: "Login",
        logout: "Logout",
        loginAsGuest: "View as Guest (Read-only)"
    },
    matches: {
        title: "Matches",
        match: "Match",
        matches: "Matches",
        createMatch: "Create Match",
        editMatch: "Edit Match",
        noMatches: "No matches found",
        createFirst: "Create your first match",
        matchId: "Match ID",
        matchDate: "Match Date",
        startTime: "Start Time",
        endTime: "End Time",
        teams: "Teams",
        player: "Player",
        organizer: "Organizer",
        playground: "Playground",
        reservation: "Reservation",
        capacity: "Capacity",
        maxCapacity: "Max Capacity",
        joinMatch: "Join Match",
        leaveMatch: "Leave Match",
        participants: "Participants",
        noResultsFound: "No matches found matching your search",
        searchByTeam: "Search by team name...",
        allTournaments: "All tournaments",
        confirmDelete: "Delete Match",
        deleteWarning: "Are you sure you want to delete this match? This action cannot be undone.",
        deleteSuccess: "Match deleted successfully",
        createSuccess: "Match created successfully",
        updateSuccess: "Match updated successfully",
        notFound: "Match not found",
        tournamentInfo: "Tournament Info",
        teamsAndScores: "Teams & Scores",
        editScore: "Edit Score",
        scoreUpdated: "Score updated successfully",
        sort: {
            dateDesc: "Newest first",
            dateAsc: "Oldest first",
            status: "By status"
        },
        status: {
            title: "Status",
            allStatuses: "All Statuses",
            pending: "Pending",
            inProgress: "In Progress", 
            completed: "Completed",
            cancelled: "Cancelled",
            in_progress: "In Progress"
        },
        statusUpdated: "Match status updated successfully",
        eventsCanOnlyBeManaged: "Events can only be managed for matches with status \"In Progress\"",
        noTournament: "No tournament",
        unknownStatus: "Unknown",
        round: {
            notSpecified: "No round",
            missedScore: "Missed score update"
        },
        actions: {
            startMatch: "Start Match",
            endMatch: "End Match", 
            updateStatus: "Update Status"
        },
        form: {
            tournament: "Tournament (Optional)",
            matchDate: "Match Date & Time",
            startTime: "Start Time",
            endTime: "End Time",
            roundNumber: "Round / Tour Number (for round-robin formats)",
            roundNumberPlaceholder: "E.g., 1, 2, 3 or Round 1, Tour 1",
            city: "City",
            selectCity: "Select a city",
            sportType: "Sport Type",
            selectSportType: "Select a sport type",
            playground: "Playground",
            selectPlayground: "Select a playground",
            maxCapacity: "Maximum Capacity",
            description: "Description",
            descriptionPlaceholder: "Enter match description...",
            teams: "Select Teams",
            selectTournament: "Select a tournament",
            noTeams: "No teams available",
            success: "Match saved successfully",
            errors: {
                dateRequired: "Match date is required",
                startTimeRequired: "Start time is required",
                endTimeRequired: "End time is required",
                endTimeAfterStart: "End time must be after start time",
                teamsRequired: "At least one team is required",
                minimumTwoTeams: "At least two teams must be selected",
                cityRequired: "City is required",
                sportTypeRequired: "Sport type is required",
                playgroundRequired: "Playground is required",
                maxCapacityRequired: "Maximum capacity is required",
                descriptionRequired: "Description is required"
            }
        }
    },
    matchParticipants: {
        title: "Match Participants",
        participant: "Participant",
        createParticipant: "Add Participant",
        editParticipant: "Edit Participant",
        noParticipants: "No participants found",
        createFirst: "Add the first participant",
        playerId: "Player ID",
        playerName: "Player Name",
        selectPlayer: "Select Player",
        teamId: "Team ID",
        teamName: "Team Name",
        selectTeam: "Select Team",
        position: "Position",
        selectPosition: "Select Position",
        status: "Status",
        selectStatus: "Select Status",
        paymentStatus: "Payment Status",
        selectPaymentStatus: "Select Payment Status",
        amount: "Amount",
        paymentDate: "Payment Date",
        notes: "Notes",
        notesPlaceholder: "Additional notes...",
        joinedAt: "Joined At",
        team: "Team",
        user: "User",
        score: "Score", 
        paid: "Paid",
        unpaid: "Unpaid",
        processPayment: "Process Payment",
        matchInformation: "Match Information",
        matchId: "Match ID",
        participantDetails: "Participant Details",
        player: "Player",
        selectUser: "Select User",
        paymentInformation: "Payment Information",
        hasPaid: "Has Paid",
        amountPaid: "Amount Paid",
        paymentMethod: "Payment Method",
        paymentMethodPlaceholder: "Enter payment method",
        isOrganizer: "Is Organizer",
        confirmDelete: "Delete Participant",
        deleteWarning: "Are you sure you want to delete this participant? This action cannot be undone.",
        deleteSuccess: "Participant deleted successfully",
        createSuccess: "Participant added successfully",
        updateSuccess: "Participant updated successfully",
        notFound: "Participant not found",
        alreadyParticipating: "This player is already participating in the match",
        positions: {
            goalkeeper: "Goalkeeper",
            defender: "Defender",
            midfielder: "Midfielder",
            forward: "Forward",
            substitute: "Substitute"
        },
        statuses: {
            pending: "Pending",
            confirmed: "Confirmed",
            cancelled: "Cancelled", 
            no_show: "No Show",
            waiting_payment: "Waiting Payment",
            waitingPayment: "Waiting Payment"
        },
        paymentStatuses: {
            pending: "Pending Payment",
            paid: "Paid",
            refunded: "Refunded",
            cancelled: "Cancelled"
        },
        form: {
            basicInfo: "Basic Information",
            paymentInfo: "Payment Information",
            additionalInfo: "Additional Information",
            success: "Participant saved successfully",
            errors: {
                playerRequired: "Player is required",
                positionRequired: "Position is required",
                statusRequired: "Status is required",
                paymentStatusRequired: "Payment status is required",
                amountRequired: "Amount is required",
                amountPositive: "Amount must be positive"
            }
        },
        search: {
            searchByPlayer: "Search by player name...",
            allTeams: "All Teams",
            allPositions: "All Positions",
            allStatuses: "All Statuses",
            allPaymentStatuses: "All Payment Statuses"
        }
    },
    matchEvents: {
        title: "Match Events",
        addEvent: "Add Event",
        noEvents: "No events recorded for this match",
        eventType: "Event Type",
        eventTime: "Event Time",
        minute: "Minute",
        minutes: "minutes",
        eventTimePlaceholder: "Enter minute (e.g. 45)",
        minutePlaceholder: "Enter minute (e.g. 45)",
        descriptionPlaceholder: "Optional description...",
        addEventSuccess: "Event added successfully",
        deleteEventSuccess: "Event deleted successfully",
        deleteEventConfirm: "Are you sure you want to delete this event?",
        eventsTitle: "Match Events",
        types: {
            goal: "Goal",
            yellow_card: "Yellow Card",
            red_card: "Red Card",
            second_yellow: "Second Yellow",
            penalty_goal: "Penalty Goal",
            missed_penalty: "Missed Penalty",
            own_goal: "Own Goal"
        }
    },
    teams: {
        title: "Teams",
        createTeam: "Create Team",
        editTeam: "Edit Team",
        noTeams: "No teams found",
        createFirst: "Create your first team",
        name: "Team Name",
        description: "Description",
        primaryColor: "Primary Color",
        secondaryColor: "Secondary Color",
        players: "Players",
        noPlayers: "No players assigned to this team",
        confirmDelete: "Delete Team",
        deleteWarning: "Are you sure you want to delete this team? This action cannot be undone.",
        deleteWarningDetail: "Are you sure you want to delete '{name}'? This action cannot be undone.",
        notFound: "Team not found",
        addPlayers: "Add Players",
        noPlayersSelected: "No players selected",
        playersSelected: "players selected",
        noResultsFound: "No teams found matching your search",
        changeAvatar: "Change Avatar",
        uploadAvatarHint: "Upload a new team avatar (max 5MB)",
        city: "City",
        enterCityId: "Enter city ID",
        sportType: "Sport Type",
    },
    tournaments: {
        title: "Tournaments",
        createTournament: "Create Tournament",
        editTournament: "Edit Tournament",
        noTournaments: "No tournaments found",
        createFirst: "Create your first tournament",
        name: "Tournament Name",
        description: "Description",
        startDate: "Start Date",
        endDate: "End Date",
        teams: "Teams",
        noTeams: "No teams assigned to this tournament",
        confirmDelete: "Delete Tournament",
        deleteWarning: "Are you sure you want to delete this tournament? This action cannot be undone.",
        deleteWarningDetail: "Are you sure you want to delete '{name}'? This action cannot be undone.",
        notFound: "Tournament not found",
        addTeams: "Add Teams",
        noTeamsSelected: "No teams selected",
        teamsSelected: "teams selected",
        maxTeamsReached: "Maximum team limit reached",
        noResultsFound: "No tournaments found matching your search",
        selectTeams: "Select Teams",
        tournamentDetails: "Tournament Details",
        basicInfo: "Tournament Info",
        dateRange: "Date Range",
        searchByTournament: "Search by tournament name or description...",
        searchByName: "Search by name...",
        filterByDate: "Filter by date",
        registrationDeadline: "Registration Deadline",
        status: "Status",
        format: "Format",
        hasReturnMatches: "Has Return Matches",
        roundRobin: "Round Robin",
        singleElimination: "Single Elimination",
        doubleElimination: "Double Elimination",
        swiss: "Swiss System",
        maxTeams: "Max Teams",
        prizePool: "Prize Pool",
        statusUpcoming: "Upcoming",
        statusActive: "Active",
        statusCompleted: "Completed",
        statusCancelled: "Cancelled",
        formatSingleElimination: "Single Elimination",
        formatDoubleElimination: "Double Elimination",
        formatRoundRobin: "Round Robin",
        formatSwiss: "Swiss System",
        addMoreTeams: "Add more teams",
        enterName: "Enter tournament name",
        selectStartDate: "Select start date",
        selectEndDate: "Select end date",
        selectedTeams: "Selected Teams",
        city: "City",
        sportType: "Sport Type",
        category: "Tournament Category",
        numberOfMatches: "Number of Matches",
        matchesCountLabel: "matches",
        teamPairsLabel: "team pairs",
        selectRoundToViewMatches: "Select round to view matches",
        pairAssignments: "Pair assignments in this round:",
        location: "Location",
        schedule: "Round Schedule",
        generateSchedule: "Generate Schedule",
        regenerateSchedule: "Regenerate Schedule",
        nameRequired: "Tournament name is required",
        startDateRequired: "Start date is required",
        endDateRequired: "End date is required",
        cityRequired: "City is required",
        sportTypeRequired: "Sport type is required",
        categoryRequired: "Category is required",
        minTeamsRequired: "Minimum 2 teams required"
    },
    common: {
        or: "or",
        save: "Save",
        cancel: "Cancel",
        remove: "Remove",
        delete: "Delete",
        edit: "Edit",
        create: "Create",
        update: "Update",
        warning: "Warning",
        loading: "Loading...",
        saving: "Saving...",
        deleting: "Deleting...",
        notSpecified: "Not specified",
        notSet: "Not set",
        image: "Image",
        viewImage: "View Image",
        viewGif: "View GIF",
        search: "Search",
        searchByName: "Search by name",
        searchByPosition: "Search by position, club or nationality",
        viewDetails: "View Details",
        backToList: "Back to List",
        actions: "Actions",
        createdAt: "Created At",
        noDataAvailable: "No data available",
        previous: "Previous",
        next: "Next",
        of: "of",
        showing: "Showing",
        page: "Page",
        filter: "Filter",
        filterOptions: "Filter Options",
        filters: "Filters",
        apply: "Apply",
        reset: "Reset",
        all: "All",
        clearAll: "Clear All",
        add: "Add",
        active: "Active",
        inactive: "Inactive",
        status: "Status",
        description: "Description",
        confirmDelete: "Confirm Delete",
        notFound: "Not Found",
        additionalInformation: "Additional Information",
        dashboard: "Dashboard",
        min: "Min",
        max: "Max",
        selectTeam: "Select Team",
        teamId: "Team ID",
        noTeamsFound: "No teams found",
        loadingTeams: "Loading teams...",
        noDescription: "No description",
        yes: "Yes",
        no: "No",
        metadata: "Metadata",
        updatedAt: "Updated At",
        years: "years",
        none: "None",
        close: "Close",
        back: "Back",
        goToMatchesToManageParticipants: "Go to matches to manage participants",
        days: {
            monday: "Monday",
            tuesday: "Tuesday",
            wednesday: "Wednesday",
            thursday: "Thursday",
            friday: "Friday",
            saturday: "Saturday",
            sunday: "Sunday"
        },
        creation: {
            success: "Created successfully",
            error: "Creation failed"
        },
        deleteStatus: {
            success: "Deleted successfully",
            error: "Deletion failed",
            confirm: "Are you sure you want to delete this item?",
            warning: "This action cannot be undone."
        },
        errors: {
            general: "An error occurred",
            notFound: "Item not found",
            validation: "Please fix the validation errors",
            required: "This field is required",
            failedToLoadPlayers: "Failed to load player details",
            failedToLoadTeams: "Failed to load team details"
        },
    },
    players: {
        title: "Players",
        createPlayer: "Create Player",
        editPlayer: "Edit Player",
        noPlayers: "No players found",
        noPlayersAvailable: "No players available",
        createFirst: "Create your first player",
        fullName: "Full Name",
        fullNamePlaceholder: "Enter player's full name",
        searchPlaceholder: "Search by name, position, or nationality",
        position: "Position",
        club: "Club",
        team: "Team",
        selectTeam: "Select team",
        age: "Age",
        height: "Height",
        weight: "Weight",
        nationality: "Nationality",
        birthplace: "Birthplace",
        searchUser: "Search user...",
        userAssignment: "User Assignment",
        user: "User",
        preferredFoot: "Preferred Foot",
        leftFoot: "Left",
        rightFoot: "Right",
        bothFeet: "Both",
        bio: "Biography",
        noBio: "No biography provided",
        identificationNumber: "ID Number",
        number: "Number",
        userId: "User ID",
        heroId: "Hero ID",
        heroIdPlaceholder: "Enter hero ID (optional)",
        heroGif: "Hero GIF",
        player: "Player",
        confirmDelete: "Delete Player",
        deleteWarning: "Are you sure you want to delete this player? This action cannot be undone.",
        deleteWarningDetail: "Are you sure you want to delete the player with position '{position}'? This action cannot be undone.",
        notFound: "Player not found",
        playerDetails: "Player Details",
        basicInfo: "Basic Info",
        physicalData: "Physical Data",
        nationalityInfo: "Nationality",
        additionalInfo: "Additional Info",
        biography: "Biography",
        noResultsFound: "No players found matching your search",
        changeAvatar: "Change Avatar",
        uploadAvatarHint: "Upload a new avatar image (max 5MB)",
        unknownPlayer: "Unknown Player",
        filter: {
            byTeam: "Filter by team",
            byPosition: "Filter by position",
            byNationality: "Filter by nationality"
        },
        positions: {
            goalkeeper: "Goalkeeper",
            centerBack: "Center Back",
            leftBack: "Left Back",
            rightBack: "Right Back",
            leftWingBack: "Left Wing Back",
            rightWingBack: "Right Wing Back",
            centralDefensiveMidfielder: "Central Defensive Midfielder",
            centralMidfielder: "Central Midfielder",
            leftMidfielder: "Left Midfielder",
            rightMidfielder: "Right Midfielder",
            centralAttackingMidfielder: "Central Attacking Midfielder",
            leftWing: "Left Wing",
            rightWing: "Right Wing",
            striker: "Striker",
            centerForward: "Center Forward"
        }
    },
    sportTypes: {
        title: "Sport Types",
        subtitle: "Manage sport types and their configurations",
        sportType: "Sport Type",
        createSportType: "Create Sport Type",
        editSportType: "Edit Sport Type",
        noSportTypes: "No sport types found",
        createFirst: "Create your first sport type",
        name: "Name",
        namePlaceholder: "Enter sport type name",
        description: "Description",
        descriptionPlaceholder: "Enter sport type description",
        teamBased: "Team Based",
        minTeamSize: "Minimum Team Size",
        maxTeamSize: "Maximum Team Size",
        teamSize: "Team Size",
        teamConfiguration: "Team Configuration",
        active: "Active",
        basicInfo: "Basic Info",
        sportTypeDetails: "Sport Type Details",
        confirmDelete: "Delete Sport Type",
        deleteWarning: "Are you sure you want to delete this sport type? This action cannot be undone.",
        deleteWarningDetail: "Are you sure you want to delete '{name}'? This action cannot be undone.",
        notFound: "Sport type not found",
        searchByName: "Search by name...",
        selectSportType: "Select sport type",
        allSportTypes: "All Sport Types",
        unknownSportType: "Unknown Sport Type",
    },
    countries: {
        title: "Countries",
        subtitle: "Manage countries and their information",
        pageDescription: "View and manage countries, their codes, and associated cities",
        country: "Country",
        createCountry: "Create Country",
        editCountry: "Edit Country",
        viewCountry: "View Country",
        noCountries: "No countries found",
        createFirst: "Create your first country",
        searchPlaceholder: "Search by name or code...",
        confirmDelete: "Are you sure you want to delete {name}?",
        fields: {
            name: "Name",
            code: "Code",
            isoCode2: "ISO Code 2",
            cities: "Cities",
            active: "Active"
        },
        placeholders: {
            name: "Enter country name",
            code: "Enter country code (3 letters)",
            isoCode2: "Enter ISO code (2 letters)"
        },
        validation: {
            nameRequired: "Country name is required",
            codeRequired: "Country code is required",
            codeLength: "Country code must be exactly 3 characters",
            isoCode2Required: "ISO Code 2 is required",
            isoCode2Length: "ISO Code 2 must be exactly 2 characters"
        }
    },
    cities: {
        title: "Cities",
        city: "City",
        createCity: "Create City",
        editCity: "Edit City",
        noCities: "No cities found",
        createFirst: "Create your first city",
        name: "Name",
        country: "Country",
        selectCountry: "Select a country",
        region: "Region",
        population: "Population",
        latitude: "Latitude",
        longitude: "Longitude",
        postalCode: "Postal Code",
        location: "Location",
        coordinates: "Coordinates",
        coordinatesRequired: "Please select location on map",
        selectOnMap: "Select on Map",
        selectCity: "Select city",
        allCities: "All cities",
        unknownCity: "Unknown city",
        cityDetails: "City Details",
        confirmDelete: "Delete City",
        deleteWarning: "Are you sure you want to delete this city? This action cannot be undone.",
        deleteWarningDetail: "Are you sure you want to delete '{name}'? This action cannot be undone.",
        notFound: "City not found",
        searchByName: "Search by name...",
        searchByCountry: "Search by country...",
        searchByRegion: "Search by region...",
        filterByCountry: "Filter by country",
        filterByRegion: "Filter by region",
        basicInfo: "Basic Information",
        geographicInfo: "Geographic Information",
        demographics: "Demographics"
    },
    validations: {
        phoneRequired: "Phone number is required",
        phoneInvalid: "Phone must start with '+' followed by 10-15 digits",
        passwordRequired: "Password is required",
        passwordShort: "Password must be at least 6 characters long",
        nameRequired: "Name is required",
        nameShort: "Name must be at least 2 characters long",
        descriptionRequired: "Description is required",
        colorRequired: "Color is required",
        positionRequired: "Position is required",
        clubRequired: "Club is required",
        nationalityRequired: "Nationality is required",
        birthplaceRequired: "Birthplace is required",
        ageInvalid: "Age must be greater than 0",
        heightInvalid: "Height must be greater than 0",
        weightInvalid: "Weight must be greater than 0",
        identificationRequired: "ID Number is required",
        startDateRequired: "Start date is required",
        endDateRequired: "End date is required",
        endDateAfterStart: "End date must be after start date",
        registrationDeadlineBeforeStart: "Registration deadline must be before start date",
        minTeams: "Minimum 2 teams required",
        prizePoolPositive: "Prize pool must be positive"
    },
    languages: {
        en: "English",
        ru: "Russian"
    },
    statistics: {
        tournamentTable: "Tournament Table",
        recentMatches: "Recent Matches",
        overview: "Statistics Overview",
        noStatistics: "No statistics available",
        noMatches: "No matches found",
        team: "Team",
        played: "P",
        wins: "W",
        draws: "D",
        losses: "L",
        goalsFor: "GF",
        goalsAgainst: "GA",
        goalDiff: "GD",
        points: "Pts",
        win: "Win",
        loss: "Loss",
        draw: "Draw",
        totalMatches: "Total Matches",
        winRate: "Win Rate",
        goalsScored: "Goals Scored",
        goalsConceded: "Goals Conceded",
        loadMore: "Load More",
        playerStatistics: "Player Statistics",
        noPlayerStats: "No player statistics available",
        matchesPlayed: "Matches Played",
        goals: "Goals",
        assists: "Assists",
        playerSummary: "Player Summary",
        goalsPerMatch: "Goals per Match",
        assistsPerMatch: "Assists per Match"
    },
    playgrounds: {
        title: "Playgrounds",
        playground: "Playground",
        createPlayground: "Create Playground",
        editPlayground: "Edit Playground",
        noPlaygrounds: "No playgrounds found",
        createFirst: "Create your first playground",
        name: "Name",
        location: "Location",
        description: "Description",
        pricePerHour: "Price per Hour",
        maxCapacity: "Max Capacity",
        currentCapacity: "Current Capacity",
        availableFrom: "Available From",
        availableTo: "Available To",
        status: "Status",
        active: "Active",
        inactive: "Inactive",
        capacity: "Capacity",
        hours: "Hours",
        pricing: "Pricing",
        workingHours: "Working Hours",
        currentMax: "Current / Max",
        images: "Images",
        details: "Details",
        reservations: "Reservations",
        reservationHistory: "Reservation History",
        reservationPeriod: "Reservation Period",
        user: "User",
        noReservations: "No reservations found",
        confirmDelete: "Delete Playground",
        deleteWarning: "Are you sure you want to delete playground '{name}'? This action cannot be undone.",
        notFound: "Playground not found",
        searchByName: "Search by name...",
        searchByLocation: "Search by location...",
        minPrice: "Min price",
        maxPrice: "Max price",
        namePlaceholder: "Enter playground name",
        locationPlaceholder: "Enter location address", 
        descriptionPlaceholder: "Enter playground description",
        fieldSize: "Field Size",
        fieldSizePlaceholder: "e.g., 40x20 meters",
        fieldCoverType: "Field Cover Type",
        selectFieldCoverType: "Select cover type",
        fieldCoverTypes: {
            outdoor: "Outdoor",
            indoor: "Indoor",
            semiCovered: "Semi-covered"
        },
        fieldSurfaceType: "Field Surface Type",
        selectFieldSurfaceType: "Select surface type",
        fieldSurfaceTypes: {
            artificialGrass: "Artificial Grass",
            naturalGrass: "Natural Grass",
            concrete: "Concrete",
            rubber: "Rubber",
            sand: "Sand"
        },
        address: "Address",
        addressPlaceholder: "Enter playground address",
        coordinatesPlaceholder: "Coordinates will be set automatically",
        selectOnMap: "Select on Map",
        validation: {
            cityRequired: "City is required",
            pricePositive: "Price must be positive",
            capacityPositive: "Max capacity must be positive",
            currentCapacityValid: "Current capacity must be valid",
            currentCapacityNotExceedMax: "Current capacity cannot exceed max capacity",
            availableFromRequired: "Available from time is required",
            availableToRequired: "Available to time is required",
            availableToAfterFrom: "Available to time must be after available from time",
            fieldSizeRequired: "Field size is required",
            fieldCoverTypeRequired: "Field cover type is required",
            fieldSurfaceTypeRequired: "Field surface type is required",
            addressRequired: "Address is required",
            coordinatesRequired: "Coordinates are required"
        },
        changeImage: "Change Image",
        uploadImageHint: "Upload a new playground image (max 5MB)",
        facilities: "Facilities"
    },
    playgroundFacilities: {
        title: "Playground Facilities",
        subtitle: "Manage facilities available at playgrounds",
        pageDescription: "Create and manage playground facilities for better service",
        facility: "Facility",
        facilities: "Facilities",
        createFacility: "Create Facility",
        editFacility: "Edit Facility",
        assignFacilities: "Assign Facilities",
        removeAllFacilities: "Remove All Facilities",
        allFacilities: "All Facilities",
        assignedFacilities: "Assigned Facilities",
        availableFacilities: "Available Facilities",
        selectedFacilities: "Selected Facilities",
        assignSelected: "Assign Selected",
        noFacilities: "No facilities found",
        noAssignedFacilities: "No facilities assigned to this playground",
        noAvailableFacilities: "No available facilities to assign",
        name: "Name",
        description: "Description",
        category: "Category",
        icon: "Icon",
        quantity: "Quantity",
        notes: "Notes",
        preview: "Preview",
        namePlaceholder: "Enter facility name",
        descriptionPlaceholder: "Enter facility description",
        searchPlaceholder: "Search facilities...",
        notesPlaceholder: "Additional notes (optional)",
        selectCategory: "Select Category",
        selectIcon: "Select Icon",
        customIconPlaceholder: "Or enter custom icon code",
        iconHint: "Choose from predefined icons or enter custom icon code",
        confirmDelete: "Are you sure you want to delete this facility?",
        confirmRemoveFromPlayground: "Are you sure you want to remove this facility from the playground?",
        confirmRemoveAll: "Are you sure you want to remove all facilities from this playground?",
        categories: {
            sports: "Sports Equipment",
            safety: "Safety & Security",
            comfort: "Comfort & Amenities",
            utilities: "Utilities",
            entertainment: "Entertainment",
            accessibility: "Accessibility"
        },
        icons: {
            ball: "Ball",
            goal: "Goal",
            lighting: "Lighting",
            parking: "Parking",
            restroom: "Restroom",
            water: "Water Fountain",
            bench: "Bench",
            security: "Security Camera",
            wifi: "WiFi",
            accessibility: "Accessibility"
        }
    },
    regions: {
        description: "Overview of regions and cities distribution",
        totalRegions: "Total Regions",
        totalCities: "Total Cities",
        activeCities: "Active Cities",
        searchByRegion: "Search by region or country...",
        allCountries: "All Countries",
        noResultsFound: "No regions found",
        noRegions: "No regions available",
        createFirstCity: "Create your first city to start seeing regions",
        cities: "Cities",
        citiesList: "Cities List",
        viewCities: "View Cities",
        manageCities: "Manage Cities"
    },
    files: {
        title: "File Management",
        description: "Upload and manage files and images",
        uploadSection: "Upload Files",
        displaySection: "Display Files",
        selectType: "Select File Type",
        objectId: "Object ID",
        singleUpload: "Single File Upload",
        multipleUpload: "Multiple Files Upload",
        displayByObject: "Display by Object",
        objectDisplayInfo: "Showing {{type}} for object ID {{objectId}}",
        recentUploads: "Recent Uploads",
        noFiles: "No files uploaded yet",
        clickToUpload: "Click to upload",
        orDragAndDrop: "or drag and drop",
        upTo: "up to",
        uploading: "Uploading...",
        uploadComplete: "Upload complete",
        uploadFailed: "Upload failed",
        fileTooBig: "File is too big. Maximum size is {{maxSize}}MB",
        invalidFileType: "Invalid file type. Accepted types: {{accept}}",
        selectFiles: "Select Files",
        selectedFiles: "Selected Files",
        removeFile: "Remove file",
        uploadFiles: "Upload Files",
        types: {
            'team-avatar': "Team Avatar",
            'user-avatar': "User Avatar", 
            'playground-avatar': "Playground Avatar",
            'sport-club-avatar': "Sport Club Avatar",
            'sport-club-hero': "Sport Club Hero Image",
            'tournament-logo': "Tournament Logo",
            'player-avatar': "Player Avatar",
            'match-photo': "Match Photo",
            'achievement-icon': "Achievement Icon",
            'general': "General File"
        },
        error: {
            fileTooBig: "File is too big. Maximum size is {{maxSize}}MB",
            invalidFileType: "Invalid file type. Accepted types: {{accept}}",
            uploadFailed: "Upload failed. Please try again.",
            loadFailed: "Failed to load image"
        }
    },
    achievements: {
        title: "Achievements",
        description: "Manage player achievements and awards",
        createAchievement: "Create Achievement",
        editAchievement: "Edit Achievement", 
        achievement: "Achievement",
        player: "Player",
        achievementDate: "Achievement Date",
        category: "Category",
        points: "Points",
        featured: "Featured",
        createdAt: "Created At",
        playerId: "Player ID",
        selectPlayer: "Select a player",
        selectCategory: "Select a category",
        titlePlaceholder: "Enter achievement title",
        descriptionPlaceholder: "Enter achievement description",
        pointsPlaceholder: "Enter points (optional)",
        noAchievements: "No achievements found for this player",
        playerAchievements: "Player Achievements",
        achievementsTitle: "Achievements",
        categories: {
            tournament_winner: "Tournament Winner",
            best_player: "Best Player",
            top_scorer: "Top Scorer",
            most_assists: "Most Assists",
            fair_play: "Fair Play",
            rookie_of_year: "Rookie of the Year",
            veteran_achievement: "Veteran Achievement",
            team_captain: "Team Captain",
            milestone: "Milestone",
            special_award: "Special Award"
        },
        categoryDescriptions: {
            tournament_winner: "Awarded to tournament champions",
            best_player: "Outstanding individual performance",
            top_scorer: "Highest goal scorer in competition",
            most_assists: "Most assists in competition",
            fair_play: "Exemplary sportsmanship",
            rookie_of_year: "Best newcomer performance",
            veteran_achievement: "Long-term contribution to sport",
            team_captain: "Leadership excellence",
            milestone: "Career milestone achievement",
            special_award: "Special recognition award"
        },
        searchByTitle: "Search by title...",
        allCategories: "All Categories",
        allPlayers: "All Players",
        allAchievements: "All Achievements",
        featuredOnly: "Featured Only",
        regularOnly: "Regular Only",
        totalAchievements: "Total Achievements",
        featuredAchievements: "Featured Achievements",
        uniquePlayers: "Unique Players",
        noResultsFound: "No achievements found matching your search",
        createFirst: "Create your first achievement",
        tryDifferentFilters: "Try adjusting your search filters",
        confirmDelete: "Delete Achievement",
        deleteWarning: "Are you sure you want to delete this achievement? This action cannot be undone.",
        deleteWarningDetail: "Are you sure you want to delete '{name}'? This action cannot be undone.",
        notFound: "Achievement not found",
        achievementNotFoundDescription: "The achievement you're looking for doesn't exist or has been deleted.",
        backToList: "Back to Achievements",
        clickToViewPlayer: "Click to view player details",
        details: "Achievement Details",
        quickStats: "Quick Stats",
        categoryInfo: "Category Information",
        type: "Type",
        regular: "Regular",
        noPoints: "No points assigned",
        validation: {
            playerRequired: "Player is required",
            titleRequired: "Title is required",
            descriptionRequired: "Description is required",
            dateRequired: "Achievement date is required",
            categoryRequired: "Category is required",
            pointsPositive: "Points must be positive or zero"
        }
    },
    tournamentCategories: {
        title: "Tournament Categories",
        description: "Manage tournament categories",
        name: "Category Name",
        categoryInformation: "Category Information",
        categoryDetails: "Category details and information",
        categoryId: "Category ID",
        create: "Create Category",
        edit: "Edit Category",
        list: "Categories List",
        total: "Total Categories",
        noCategories: "No categories found",
        createFirst: "Create your first category",
        searchName: "Search by name...",
        namePlaceholder: "Enter category name",
        descriptionPlaceholder: "Enter category description",
        backToList: "Back to Categories",
        notFound: "Category not found",
        notFoundDescription: "The category you're looking for doesn't exist or has been removed.",
        deleteConfirmation: "Are you sure you want to delete the category '{name}'? This action cannot be undone.",
        selectCategory: "Select category",
        allCategories: "All Categories",
        unknownCategory: "Unknown Category",
        validation: {
            nameRequired: "Category name is required",
            nameMinLength: "Category name must be at least 2 characters",
            nameMaxLength: "Category name must not exceed 100 characters",
            descriptionRequired: "Description is required", 
            descriptionMinLength: "Description must be at least 5 characters",
            descriptionMaxLength: "Description must not exceed 500 characters"
        }
    },
    users: {
        title: "Users",
        subtitle: "Manage system users and their roles",
        createUser: "Create User",
        editUser: "Edit User",
        userDetails: "User Details",
        noUsers: "No users found",
        createFirst: "Create your first user",
        basicInfo: "Basic Information",
        firstname: "First Name",
        lastname: "Last Name",
        phone: "Phone",
        password: "Password",
        passwordOptional: "Leave empty to keep current password",
        passwordHint: "Leave empty to keep current password",
        roles: "Roles",
        manageRoles: "Manage Roles",
        name: "Name",
        userId: "User ID",
        totalRoles: "Total Roles",
        userStatus: "Status",
        noRoles: "No roles assigned",
        confirmDelete: "Confirm Delete",
        deleteWarning: "Are you sure you want to delete user {name}? This action cannot be undone.",
        deleteWarningDetail: "Are you sure you want to delete user {name}? This action cannot be undone and will remove all associated data.",
        notFound: "User not found",
        firstnamePlaceholder: "Enter first name",
        lastnamePlaceholder: "Enter last name",
        phonePlaceholder: "Enter phone number",
        passwordPlaceholder: "Enter password",
        searchByFirstname: "Search by first name...",
        searchByLastname: "Search by last name...",
        searchByPhone: "Search by phone...",
        sortBy: "Sort by",
        sortDirection: "Sort direction",
        ascending: "Ascending",
        descending: "Descending",
        validation: {
            selectRole: "At least one role must be selected"
        }
    },
    debug: {
        performanceMonitor: "Performance Monitor",
        totalRenders: "Total Renders",
        avgTime: "Avg Time",
        slowestComponent: "Slowest Component",
        recentRenders: "Recent Renders",
        clear: "Clear",
        export: "Export"
    },
    sportClubs: {
        title: "Sport Clubs",
        subtitle: "Manage sport clubs and sections",
        sportClub: "Sport Club",
        createSportClub: "Create Sport Club",
        editSportClub: "Edit Sport Club",
        noSportClubs: "No sport clubs found",
        createFirst: "Create your first sport club",
        searchPlaceholder: "Search by club name...",
        basicInfo: "Basic Information",
        name: "Club Name",
        namePlaceholder: "Enter sport club name",
        description: "Description",
        descriptionPlaceholder: "Enter club description",
        clubType: "Club Type",
        sportType: "Sport Type",
        ageRange: "Age Range",
        minAge: "Minimum Age",
        maxAge: "Maximum Age",
        establishmentYear: "Establishment Year",
        established: "Established",
        membershipFee: "Membership Fee",
        clubTypes: {
            kids: "Kids",
            regular: "Regular",
            professional: "Professional",
            mixed: "Mixed"
        },
        contactInfo: "Contact Information",
        contactEmail: "Email",
        contactPhone: "Phone",
        website: "Website",
        addresses: "Addresses",
        address: "Address",
        addAddress: "Add Address",
        streetLine1: "Street Address (Line 1)",
        streetLine1Placeholder: "Enter street address",
        streetLine2: "Street Address (Line 2)",
        streetLine2Placeholder: "Additional address information",
        zipCode: "ZIP Code",
        addressDescription: "Address Description",
        addressDescriptionPlaceholder: "Description of location (e.g., 'main entrance')",
        primary: "Primary",
        setPrimary: "Set as Primary",
        location: "Location",
        coordinates: "Coordinates",
        selectOnMap: "Select on Map",
        openingHours: "Opening Hours",
        addOpeningHours: "Add Opening Hours",
        day: "Day",
        dayOfWeek: "Day of Week",
        openTime: "Open Time",
        closeTime: "Close Time",
        closed: "Closed",
        ageCategories: "Age Categories",
        ageCategoriesHint: "You can add multiple age groups (U6, U8, U10, etc.) to one club section",
        addAgeCategory: "Add Age Category",
        ageCategory: "Age Category",
        ageCategoryType: "Age Category Type",
        maxParticipants: "Max Participants",
        currentParticipants: "Current Participants",
        categoryDescription: "Category Description",
        categoryDescriptionPlaceholder: "Description for this age category",
        categoryActive: "Active",
        additionalInfo: "Additional Information",
        facilities: "Facilities & Equipment",
        facilitiesPlaceholder: "Describe available facilities and sports equipment",
        membershipBenefits: "Membership Benefits",
        membershipBenefitsPlaceholder: "Describe benefits and perks for club members",
        operatingHours: "Operating Hours",
        operatingHoursPlaceholder: "e.g., Mon-Fri 9:00-21:00, Sat-Sun 10:00-18:00",
        active: "Active",
        teams: "Teams",
        selectTeams: "Select Teams",
        nameRequired: "Club name is required",
        sportTypeRequired: "Sport type is required",
        minAgeInvalid: "Minimum age must be greater than 0",
        maxAgeInvalid: "Maximum age must be greater than minimum age",
        addressRequired: "At least one address is required",
        streetRequired: "Street address (line 1) is required",
        cityRequired: "City is required",
        emailInvalid: "Invalid email format",
        confirmDelete: "Delete Sport Club",
        deleteWarning: "Are you sure you want to delete this sport club? This action cannot be undone.",
        deleteWarningDetail: "Are you sure you want to delete the club '{name}'? This action cannot be undone.",
        notFound: "Sport club not found",
        years: "years",
        activeFilters: "Active Filters",
        goBack: "Go Back",
        heroId: "Hero Image ID",
        heroGif: "Hero GIF",
        uploadAvatar: "Upload club avatar",
        uploadHero: "Upload hero image",
        avatarUploaded: "Club avatar uploaded successfully",
        heroUploaded: "Hero image uploaded successfully",
        clubAvatar: "Club Avatar",
        heroImage: "Hero Image",
        clubImages: "Club Images",
    },
    reservations: {
        title: "Reservations",
        subtitle: "Manage playground reservations",
        noReservations: "No reservations found",
        confirmDelete: "Are you sure you want to delete this reservation?",
        form: {
            startTime: "Start Time",
            endTime: "End Time",
            submit: "Create Reservation"
        },
        validation: {
            startTimeRequired: "Start time is required",
            endTimeRequired: "End time is required",
            endTimeAfterStart: "End time must be after start time",
            startTimeInFuture: "Start time must be in the future"
        },
        status: {
            current: "Current Status",
            change: "Change Status",
            updating: "Updating status...",
            pending: "Pending",
            confirmed: "Confirmed", 
            cancelled: "Cancelled",
            completed: "Completed",
            paid: "Paid"
        },
        payment: {
            title: "Payment",
            form: {
                method: "Payment Method",
                amount: "Amount",
                submit: "Process Payment"
            },
            validation: {
                methodRequired: "Payment method is required",
                amountRequired: "Amount must be greater than 0"
            },
            methods: {
                cash: "Cash",
                card: "Card",
                bank_transfer: "Bank Transfer",
                online: "Online"
            }
        },
        details: {
            id: "Reservation ID",
            startTime: "Start Time",
            endTime: "End Time",
            userId: "User ID",
            price: "Price"
        },
        actions: {
            pay: "Pay",
            delete: "Delete"
        },
        filters: {
            userIdPlaceholder: "Enter user ID",
            startDate: "Start Date",
            endDate: "End Date"
        }
    },
    mobile: {
        tournamentMatchesTitle: "Tournament Matches",
        roundLabel: "Tour",
        loadingTournament: "Loading tournament...",
        tournamentUnavailable: "Tournament unavailable",
        team1: "Team 1",
        team2: "Team 2",
        playgroundTBD: "Playground TBD",
        loadingTable: "Loading table...",
        noTableData: "No table data yet",
        today: "TODAY",
        daysShort: {
            monday: "MON",
            tuesday: "TUE",
            wednesday: "WED",
            thursday: "THU",
            friday: "FRI",
            saturday: "SAT",
            sunday: "SUN"
        }
    },
    favorites: {
        title: "Favorites",
        subtitle: "Manage your favorite items",
        noFavorites: "No favorites yet",
        noFavoritesSubtext: "Items you favorite will appear here",
        addedOn: "Added on",
        entityTypes: {
            team: "Teams",
            tournament: "Tournaments", 
            playground: "Playgrounds",
            match: "Matches",
            player: "Players",
            sportClub: "Sport Clubs"
        },
        search: {
            placeholder: "Search favorites",
            byId: "Search by ID..."
        },
        actions: {
            addToFavorites: "Add to favorites",
            removeFromFavorites: "Remove from favorites",
            favorited: "Favorited"
        },
        messages: {
            addedToFavorites: "Added to favorites",
            removedFromFavorites: "Removed from favorites",
            errorAdding: "Error adding to favorites",
            errorRemoving: "Error removing from favorites"
        }
    }
};
